import api from './api';

const paymentService = {
  async initiateRazorpay(orderId, walletAmount = 0) {
    try {
      const response = await api.post(`/payments/razorpay/initiate/${orderId}`, { walletAmount });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to initiate payment',
      };
    }
  },

  async verifyRazorpay(paymentData) {
    try {
      const response = await api.post('/payments/razorpay/verify', {
        orderId: paymentData.orderId,
        razorpayOrderId: paymentData.razorpayOrderId,
        razorpayPaymentId: paymentData.razorpayPaymentId,
        razorpaySignature: paymentData.razorpaySignature,
      });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Payment verification failed',
      };
    }
  },

  async placeCod(orderId) {
    try {
      const response = await api.post(`/payments/cod/${orderId}`);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to place COD order',
      };
    }
  },

  async getPaymentStatus(orderId) {
    try {
      const response = await api.get(`/payments/order/${orderId}`);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to get payment status',
      };
    }
  },

  // ===== Guest Payment Methods =====

  async initiateGuestRazorpay(orderId, trackingToken) {
    try {
      const response = await api.post(`/payments/guest/razorpay/initiate/${orderId}`, { trackingToken });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to initiate payment',
      };
    }
  },

  async verifyGuestRazorpay(paymentData) {
    try {
      const response = await api.post('/payments/guest/razorpay/verify', {
        orderId: paymentData.orderId,
        trackingToken: paymentData.trackingToken,
        razorpayOrderId: paymentData.razorpayOrderId,
        razorpayPaymentId: paymentData.razorpayPaymentId,
        razorpaySignature: paymentData.razorpaySignature,
      });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Payment verification failed',
      };
    }
  },

  /**
   * Refunds owed on money collected at the door — cash, or the static UPI QR.
   * Razorpay never held that money, so nothing reverses on its own and someone
   * has to send it back. `settled` switches to the already-confirmed history.
   */
  async getManualRefunds(settled = false) {
    try {
      const response = await api.get('/payments/admin/manual-refunds', { params: { settled } });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to load manual refunds',
        data: [],
      };
    }
  },

  /** Confirm a manual refund has actually been handed back to the customer. */
  async markManualRefundSent(refundId) {
    try {
      const response = await api.patch(`/payments/admin/manual-refunds/${refundId}/mark-sent`);
      return { success: true, data: response.data };
    } catch (error) {
      const message = error.response?.data?.message;
      return {
        success: false,
        error: Array.isArray(message) ? message[0] : message || 'Failed to mark the refund as sent',
      };
    }
  },
};

export default paymentService;